module.exports = __webpack_public_path__ + "static/media/portfolio-v3-small.734df526.png";